import React from "react";
import MainProjects from "../specificComponents/MainProjects";
import SectionTem from "../SectionTem";

const MySkills = () => {
  return (
    <SectionTem id="work">
      <h1 className="w-full heading ">
        what can i do <span> .... </span>
      </h1>
      <MainProjects />
    </SectionTem>
  );
};

export default MySkills;
